import { render } from "./LastestNewsTemplate.vue?vue&type=template&id=38010656&scoped=true"
import script from "./LastestNewsTemplate.vue?vue&type=script&lang=js"
export * from "./LastestNewsTemplate.vue?vue&type=script&lang=js"

import "./LastestNewsTemplate.vue?vue&type=style&index=0&id=38010656&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38010656"]])

export default __exports__